export default {
  hasRemarketing: (state, getters) => getters.modelExists('VIDEO') || getters.modelExists('PROCESS'),

  modelExists: ({ usersModels }) => modelType => usersModels?.some(model => model.modelType === modelType),

  hasInspect: (state, getters) => getters.modelExists('INSPECT_REPAIR_ORDER'),

  hasTradeIn: (state, getters) => getters.modelExists('INSPECT'),

  typesForUser: (state, getters) => {
    const filterTypes = {
      inspect: ['INSPECTION', 'INSPECTION_REPAIR_ORDER'],
      remarketing: ['STANDARD', 'VIDEO']
    }

    const hasInspectFilters = getters.hasInspect || getters.hasTradeIn
    const hasRemarketingFilters = getters.hasRemarketing

    if (hasInspectFilters && hasRemarketingFilters) {
      return [...filterTypes.inspect, ...filterTypes.remarketing]
    }

    if (hasInspectFilters) {
      return filterTypes.inspect
    }

    if (hasRemarketingFilters) {
      return filterTypes.remarketing
    }

    return [...filterTypes.inspect, ...filterTypes.remarketing]
  }
}
